import Vue from 'vue'

const state = {
  items: {}
}

const mutations = {
  FETCH (state, currencies) {
    state.items = currencies
  }
}

const actions = {
  fetchAll: ({commit}) => {
    return Vue.prototype.$axios.get('currency-rates/get-all')
      .then(response => {
        commit('FETCH', response.data)
      })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
